/**
 * @file
 */

import { autoHeightAnimate, autoHeightAnimateClose } from './heightAnimation.js'

export default (Drupal, once) => {

  // MARK: Main menu and mobile icon
  Drupal.behaviors.mainNavigation = {
    attach (context) {
      once('main-navigation', '.site-header', context).forEach(function () {

        // MARK: Menu - toggle mobile menu.
        const menuContainer = document.querySelector('.site-header')
        const mobileMenuButton = document.getElementById('mobile-menu-button')

        mobileMenuButton.addEventListener('click', function (e) {
          e.preventDefault()

          if (menuContainer.classList.contains('mobile-menu-open')) {
            // If open, close menu
            menuContainer.classList.remove('mobile-menu-open')
            mobileMenuButton.setAttribute('aria-expanded', false)
            autoHeightAnimateClose(menuContainer, 200, 90)
          } else {
            // If closed, open menu
            mobileMenuButton.setAttribute('aria-expanded', true)
            menuContainer.classList.add('mobile-menu-open')
            autoHeightAnimate(menuContainer, 200)
          }
        })

        // click open org drop-down menu
        // ----------------------------------------------
        const organizationSelector = '.views-field.views-field-field-organization'
        const organizationLabelSelector = '.views-field.views-field-field-organization .views-label'
        const organizationElements = document.querySelectorAll(organizationSelector)
        const organizationLabelElements = document.querySelectorAll(organizationLabelSelector)

        // append drop-down arrow to menu items
        organizationLabelElements.forEach(label => {
          label.setAttribute('tabindex', 0)
          const span = document.createElement('span')
          span.innerHTML = '<i></i><i></i>'
          label.appendChild(span)
        })

        // add accessibly attributes
        organizationElements.forEach(org => {
          org.setAttribute('aria-expanded', 'false')
          org.setAttribute('aria-haspopup', 'true')
        })

        // toggle
        organizationLabelElements.forEach(label => {
          const toggleMenu = function () {
            const parent = this.closest(organizationSelector)
            if (parent.classList.contains('menu-open')) {
              parent.classList.remove('menu-open')
              parent.setAttribute('aria-expanded', 'false')
            } else {
              // Close all other open dropdowns
              document.querySelectorAll(organizationSelector).forEach(el => {
                el.classList.remove('menu-open')
                el.setAttribute('aria-expanded', 'false')
              })
              parent.classList.add('menu-open')
              parent.setAttribute('aria-expanded', 'true')
            }
          }

          label.addEventListener('click', toggleMenu)

          // Add keyboard support for Enter key when focused
          label.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
              e.preventDefault()
              toggleMenu.call(this)
            }
          })
        })

        // Hide drop-down menu on outside click
        document.addEventListener('click', function (e) {
          const openMenus = document.querySelectorAll(organizationSelector + '.menu-open')
          if (openMenus.length > 0) {
            const clickedOnLabel = e.target.closest(organizationLabelSelector)
            if (!clickedOnLabel) {
              openMenus.forEach(menu => {
                menu.classList.remove('menu-open')
                menu.setAttribute('aria-expanded', 'false')
              })
            }
          }
        })

        // Hide drop-down menu by pressing the ESC key
        document.addEventListener('keyup', function (e) {
          if (e.key === 'Escape' || e.keyCode === 27) {
            const openMenus = document.querySelectorAll(organizationSelector + '.menu-open')
            openMenus.forEach(menu => {
              menu.classList.remove('menu-open')
              menu.setAttribute('aria-expanded', 'false')
            })
          }
        })

        // ! Reset menu items on resize.
        window.onresize = function() {
          menuContainer.setAttribute('style', '')
          menuContainer.classList.remove('mobile-menu-open')
        }

      })
    }
  }
}
